import { supabase } from './supabase';
import { logNegotiationAction } from './negotiationLogger';
import { Negociacao, Profile } from '../../types';

/**
 * Repassa o aviso de "termo assinado, aguardando análise cadastral" para outro
 * analista/gerente/adm — não muda o status nem o responsável da negociação:
 * a fila continua visível para qualquer um do departamento Pós Venda, isso é
 * só um aviso direcionado (nota no feed + notificação no sino do destino).
 * Mesmo padrão de `transferApproval` em discountApproval.ts.
 */
export const transferirAnaliseTermo = async (
    negotiation: Pick<Negociacao, 'id' | 'cliente_nome'>,
    fromUserId: string,
    fromUserName: string | null | undefined,
    toProfile: Pick<Profile, 'id' | 'full_name'>
) => {
    await supabase.from('negociacao_notas').insert({
        negociacao_id: negotiation.id,
        user_id: fromUserId,
        conteudo: `[TERMO_ANALISE_TRANSFERIDA] ${fromUserName || 'Alguém do Pós Venda'} transferiu a validação de dados deste termo assinado para ${toProfile.full_name}.`,
        tipo: 'nota'
    });

    const { error: notifyError } = await supabase.from('notifications').insert({
        user_id: toProfile.id,
        type: 'negotiation_assigned',
        title: 'Validação de dados transferida para você',
        content: `${fromUserName || 'Alguém do Pós Venda'} transferiu para você a validação de dados do termo assinado de "${negotiation.cliente_nome}".`,
        link: `/gestao?negociacaoId=${negotiation.id}`,
        read: false
    });
    if (notifyError) console.error('Error sending transfer notification:', notifyError);

    await logNegotiationAction(negotiation.id, fromUserId, `transferiu a validação de dados do termo assinado para ${toProfile.full_name}`);
};

/**
 * Adia a análise para o próprio usuário que clicou — não é global: outro
 * membro do Pós Venda continua vendo o item normalmente. Exige uma
 * observação (motivo do adiamento) e usa um prazo fixo de 1 dia (sem
 * seletor de dias, diferente do "Reagendar" do popup de desconto). A
 * data-alvo vai embutida na tag (`[TERMO_ANALISE_ADIADA:<ISO>]`) para o
 * popup conseguir filtrar sem precisar de coluna nova.
 */
export const adiarAnaliseTermo = async (
    negotiation: Pick<Negociacao, 'id'>,
    userId: string,
    userName: string | null | undefined,
    observacao: string
) => {
    const ate = new Date();
    ate.setDate(ate.getDate() + 1);

    await supabase.from('negociacao_notas').insert({
        negociacao_id: negotiation.id,
        user_id: userId,
        conteudo: `[TERMO_ANALISE_ADIADA:${ate.toISOString()}] ${userName || 'Alguém do Pós Venda'} adiou a validação de dados deste termo — ${observacao}`,
        tipo: 'nota'
    });

    await logNegotiationAction(negotiation.id, userId, `adiou a validação de dados do termo assinado: ${observacao}`);
};
